import VideoGallery from './template-parts/video-gallery/video-gallery';
var $ = jQuery;
$(function () {
  new VideoGallery();
});